import React from "react";
import createReactClass from "create-react-class";

export default createReactClass({
  displayName: "Root",
  render() {
    if (this.props.isActive) {
      return (
        // 追加中の写真のタイル。グレーの面に赤のくるくる
        <li className="alb-photo alb-photo--uploading">
          <div className="alb-photo__wrap">
            <i className="fas fa-spinner fa-pulse fa-fw" aria-hidden="true" />
            <span className="alb-photo__uploading-text">追加中…</span>
          </div>
        </li>
      );
    } else {
      return null;
    }
  },
});
